import Highcharts, { ColorType } from 'highcharts'

export const getHighchartsColorSet = (dataLength: number, isDark?: boolean) => {
  const defaultColor: ColorType[] = isDark
    ? [ '#00E0C0', '#8000FF', '#FF9040', '#00C0FF', '#FF70C0', '#FFD800' ]
    : [ '#8000FF', '#00E0C0', '#FF9040', '#00C0FF', '#FF70C0', '#FFD800' ]
  if (dataLength > 0) {
    const divider = isDark ? -3.5 : 1.5
    for (let i = 0; i < dataLength; i++) {
      defaultColor.push(
        Highcharts.color(defaultColor[i])
          .brighten(
            (i - defaultColor.length) / dataLength / divider,
          )
          .get(),
      )
    }
  }
  return defaultColor
}